import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/ui/sidebar"
import { NAV_GROUPS } from "./nav-config"
import { SidebarBrand } from "./sidebar/SidebarBrand"
import { SidebarNavGroup } from "./sidebar/SidebarNavGroup"
import { SidebarUserFooter } from "./sidebar/SidebarUserFooter"

export function AppSidebar() {
  return (
    <Sidebar collapsible="icon">
      {/* h-14 = ta sama wysokość co AppTopbar - linie nad sidebarem i topbarem łączą się */}
      <SidebarHeader className="h-14 flex-row items-center border-b border-sidebar-border px-3 py-0">
        <SidebarBrand />
      </SidebarHeader>
      <SidebarContent>
        {NAV_GROUPS.map((group) => (
          <SidebarNavGroup key={group.label} group={group} />
        ))}
      </SidebarContent>
      <SidebarFooter>
        <SidebarUserFooter />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
